import { dateFromDateStringWithAppendedTime } from '@/utils/dates';

export const isInsurancePolicyExpired = (planEndDate: string | null | undefined): boolean => {
  const endDate = planEndDate ? dateFromDateStringWithAppendedTime(planEndDate) : null;

  return Boolean(endDate && endDate < new Date());
};
